// extracted by mini-css-extract-plugin
export default {"tableRowActions":"bJxpk6mrW5qtVLOWJADM","link":"cR1lXgV5hLyNGKKKQq6Q"};